import React from 'react';

import { CATEGORY_LIST_PAGINATION_MODEL } from '../../../../store/modules/category/models';
import Table from '../../../../components/_table/Table';
import { columns } from './columns';
import './CategoryList.scss';

/**
 * 1차 카테고리 리스트를 담고 있는 테이블
 * @return {JSX.Element}
 * @constructor
 */
const CategoryList = (props) => {
  const { categories, filterOption, pagination, routeEvent, selectedList, onCheckCategoryItem } = props;

  return (
    <Table
      columns={() => columns()}
      rowKey={(record) => record.id}
      initialOption={{ pagination: CATEGORY_LIST_PAGINATION_MODEL }}
      list={categories}
      scroll={{ x: true }}
      bordered={true}
      filterOption={filterOption}
      pagination={pagination}
      getList={routeEvent}
      onCheck={(data) => {
        onCheckCategoryItem(data);
      }}
      selectedList={selectedList}
    />
  );
};

export default CategoryList;
